import ForgotPasswordWizard from "@/components/auth/ForgotPassword/ForgotPasswordWizard";

export default function ForgotPasswordPage() {
  return (
    <div className="flex size-full scroll-py-8 flex-col overflow-y-auto md:px-6 md:py-12">
      <div className="flex min-h-full w-full shrink-0 flex-col justify-center rounded-lg bg-card px-7 py-10 shadow-md sm:m-auto sm:min-h-0 sm:max-w-[600px]">
        <ForgotPasswordWizard />
      </div>
    </div>
  );
}
